import { FormControlLabel, Switch, Typography } from "@mui/material";
import { ConfiguratorTreeItemModel } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeItemModel";
import { TransformedSubConfiguratorOrListComponent } from "./treeItemModel/configuratorTreeItemQueries";
import { SxProps, Theme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStoredState } from "src/utils/useStoredState.ts";
import { HorizontalBox } from "src/components/common/box/HorizontalBox.tsx";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { AddSubConfiguratorsToTreeViewBulk } from "./AddSubConfiguratorsToTreeViewBulk.tsx";
import { AddSubConfiguratorToTreeViewSingle } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/AddSubConfiguratorToTreeViewSingle.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";

export interface SubConfigurationImportButtonAction {
	title: string;
	onClick: () => Promise<void>;
}

export interface AddSubConfiguratorsToTreeViewProps {
	treeItem: ConfiguratorTreeItemModel;
	closeDialog: () => void;
	onSubmit: (selectedComponents: TransformedSubConfiguratorOrListComponent[]) => Promise<void>;
	addSubConfiguratorButtonSx?: (
		subConfiguratorComponent: TransformedSubConfiguratorOrListComponent,
	) => SxProps<Theme>;
	addSubConfiguratorButtonContextMenu?: (params: {
		component: TransformedSubConfiguratorOrListComponent;
		closeDialog: () => void;
	}) => React.ReactNode;
	subConfigurationImportAction?: SubConfigurationImportButtonAction;
}

export const AddSubConfiguratorsToTreeView = (props: AddSubConfiguratorsToTreeViewProps) => {
	const { t } = useTranslation();

	const [useBulkInterface, setUseBulkInterface] = useStoredState<boolean>({
		type: "boolean",
		key: "A7F3B2E8D9C1F456",
		defaultValue: false,
	});

	return (
		<VerticalBox sx={{ flex: 1, margin: 2 }}>
			<HorizontalBox sx={{ justifyContent: "space-between" }}>
				{props.subConfigurationImportAction && (
					<AsyncButton
						icon={faFileImport}
						label={props.subConfigurationImportAction.title}
						onClick={props.subConfigurationImportAction.onClick}
					/>
				)}
				<FormControlLabel
					sx={{ marginLeft: "auto" }}
					control={
						<Switch
							checked={useBulkInterface}
							size={"small"}
							onChange={(_, checked) => setUseBulkInterface(checked)}
						/>
					}
					label={<Typography variant="body2">{t("multi_select")}</Typography>}
				/>
			</HorizontalBox>

			{useBulkInterface ?
				<AddSubConfiguratorsToTreeViewBulk {...props} />
			:	<AddSubConfiguratorToTreeViewSingle {...props} />}
		</VerticalBox>
	);
};
